import axios from "axios";

import { adminUrl, PAGES } from "../config/constants";
import { BORROWER, MORTGAGE_BROKER } from "../constants/contact_id_status";

export const login = (values) => async (dispatch, getState) => {
  dispatch({
    type: "SET_LOADING",
    payload: true,
  });

  dispatch({
    type: "SET_FORM_ERROR",
    payload: false,
  });

  const { contacts } = getState().form;

  const formData = new FormData();

  formData.append("action", "checkPassword");
  formData.append("email", values.email);
  formData.append("pms_password", values.pms_password);

  const { data } = await axios.post(adminUrl, formData);

  dispatch({
    type: "SET_LOADING",
    payload: false,
  });

  if (data.result === 1) {
    dispatch({
      type: "SET_USER",
      payload: {
        userId: data.data.id,
      },
    });

    if (contacts.id_status === BORROWER.value) {
      dispatch({
        type: "SET_PAGE",
        payload: PAGES.BORROWER_CREDIT,
      });

      return;
    }

    dispatch({
      type: "SET_PAGE",
      payload: PAGES.BORROWER_INFO2,
    });

    return;
  }

  dispatch({
    type: "SET_FORM_ERROR",
    payload: true,
  });
};



// WEBPACK FOOTER //
// ./src/actions/login.actions.js